import { setStep00 } from './Step00';
import { setStep01 } from './Step01';
import { lookupABN } from './searchCompany';

export const searchCompanyByABN = (abn, callback = setStep00, defaultCompany, returnList = false) => {
  return (dispatch) => {
    dispatch(callback({ loading: true }));
    return lookupABN(abn)
      .then((business) => {
        const { abn, abnStatus, entityName, acn, addressDate, addressPostcode, entityTypeName } = business;
        if (!returnList) {
          dispatch(
            callback({
              ...defaultCompany,
              abn,
              acn,
              businessName: entityName
            })
          );
        } else {
          let saveData = {
            businesses: [
              {
                abn: entityName + ` (${abn})`,
                acn,
                _business: {
                  abn,
                  abnStatus,
                  state: addressDate,
                  postcode: addressPostcode,
                  name: entityName,
                  nameType: entityTypeName
                }
              }
            ]
          };
          dispatch(callback(saveData));
        }
        return business;
      })
      .catch((err) => {
        if (err.message === 'Operation canceled by the user.') {
          return;
        }
        throw err;
      })
      .finally(() => {
        dispatch(callback({ loading: false }));
      });
  };
};

export const searchCompaniesByABN = (abn, callback = setStep01) => {
  return (dispatch) => {
    dispatch(callback({ loading: true }));
    return lookupABN(abn)
      .then((business) => {
        const {
          abn,
          abnStatus,
          entityName,
          acn,
          addressDate,
          addressPostcode,
          entityTypeName,
          addressState
        } = business;
        dispatch(
          callback({
            businesses: [
              {
                abn,
                abnStatus,
                postcode: addressPostcode,
                acn,
                state: addressState,
                name: entityName
              }
            ]
          })
        );
      })
      .catch((err) => {
        if (err.message === 'Operation canceled by the user.') {
          return;
        }
        throw err;
      })
      .finally(() => {
        dispatch(callback({ loading: false }));
      });
  };
};
